import {BaseModel} from './base.model';

export class ConfigModel extends BaseModel {

    type: string;
    value: string;
    arrayValue?: boolean;

    static validate(config: ConfigModel): boolean {
        return !!(config.type && config.value);
    }

    constructor(config?: ConfigModel) {
        super();
        this.type = config ? config.type || null : null;
        this.value = config ? config.value || null : null;
        this.arrayValue = null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/config.model.ts